import React from "react";

import AboutPage from "../About/About.js";

export default function Home() {
  return (
    <div>
    
      <AboutPage/>
     
    </div>
  );
}
